// src/utils/handleApiError.js
export function handleApiError(error) {
    if (error.response) {
        // Server responded with error status
        const message = error.response.data?.message || 'An error occurred'
        const status = error.response.status
        const details = error.response.data?.details

        return {
            message,
            status,
            details,
            isNetworkError: false
        }
    } else if (error.request) {
        // Request made but no response received
        return {
            message: 'Network error. Please check your connection.',
            status: null,
            details: null,
            isNetworkError: true
        }
    } else {
        // Something else happened
        return {
            message: error.message || 'An unexpected error occurred',
            status: null,
            details: null,
            isNetworkError: false
        }
    }
}

export function getErrorMessage(error) {
    if (typeof error === 'string') {
        return error
    }

    if (error?.message) {
        return error.message
    }

    return 'An unexpected error occurred'
}

export function isNetworkError(error) {
    return error?.isNetworkError || false
}